import { LayoutType, withLayout } from 'hocs/with-layout';
import { JoinVideoCallGuest } from './join-video-call-guest';

const WrappedJoinVideoCallGuest = withLayout(
  LayoutType.WithOldNavAndFooter,
  JoinVideoCallGuest,
);

export { WrappedJoinVideoCallGuest as JoinVideoCallGuest };
